import request from "@/utils/request";

export function agenciesGetAllForDropdown(params) {
    return request({
        url: "/api/services/app/Agency/GetAllForDropdown",
        method: "GET",
        params
    });
}




// WEBPACK FOOTER //
// ./src/api/agency.js